<p-dialog [header]="header" [(visible)]="isShow" [draggable]="true"
          [modal]="true" [style]="{}"
          [styleClass]="style"
          [appendTo]="appendTo"
          [keepInViewport]="true"
          (onHide)="onCancel()">
  <div>
    <ng-content></ng-content>
  </div>
</p-dialog>
